import { Howl, Howler } from 'howler';

export interface PlayOptions {
  url: string
  volume?: number
  pitch?: number
  remember?: boolean
  onStart?: (stop: () => void) => void
  stateChanged?: (playing: boolean) => void
  onEnd?: () => void
  onError?: (error: unknown) => void
}

class SoundManager {
  volume: number = 1;
  pitch: number = 1;

  private readonly ctx = new AudioContext();

  private readonly cache: Record<string, AudioBuffer> = {};

  setVolume(volume: number) {
    this.volume = volume;
  }

  setPitch(pitch: number, replay: boolean) {
    this.pitch = pitch;
    if (replay && this.lastOpt) {
      this.playFromUrlNew(this.lastOpt);
    }
  }

  private lastOpt?: PlayOptions

  playFromUrlNew(opt: PlayOptions): () => void {
    if (opt.remember !== false) this.lastOpt = opt;

    const howl = new Howl({
      src: opt.url,
      rate: opt.pitch ?? this.pitch,
      volume: opt.volume ?? this.volume,
    });
    let finished = false;
    let playId: number | undefined;

    const finish = () => {
      if (finished) return;
      finished = true;
      opt.stateChanged?.(false);
      opt.onEnd?.();
      howl.unload();
    };

    const stop = () => {
      if (finished) return;
      if (typeof playId === 'number') howl.stop(playId);
      else howl.stop();
      finish();
    };

    howl.on('play', id => {
      playId = id;
      opt.stateChanged?.(true);
      opt.onStart?.(stop);
    });
    howl.on('end', finish);
    howl.on('stop', finish);
    howl.on('loaderror', (_id, error) => {
      opt.onError?.(error);
      finish();
    });
    howl.on('playerror', (_id, error) => {
      opt.onError?.(error);
      finish();
    });
    playId = howl.play();
    return stop;
  }

  stopAll() {
    Howler.stop()
  }
}

export default new SoundManager();
